import { render } from "./AppointmentRecurrency.vue?vue&type=template&id=ec8acb74&ts=true"
import script from "./AppointmentRecurrency.vue?vue&type=script&lang=ts"
export * from "./AppointmentRecurrency.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__